import capitalize from 'lodash-es/capitalize';

import { publish, subscribe } from 'pub-sub';
import {
	clearView,
	viewChange,
	keymap,
	pathmap,
	quizmap,
	bonusquizzes,
	locationChange,
	whichActiveView
} from 'lcc-state';
import { assessment, bonus, quiz, practice, posttest, viewFromLpl } from './lpl';

const log = (name: string) => {
	const { path } = keymap.get(name)!;
	locationChange({ location: path });
};

function setup_locations() {
	keymap.set('', { path: '/', title: '' });
	pathmap.set('/', {
		topic: {},
		view: () => {
			publish('site/homepage');
		}
	});

	keymap.set('my-progress', { path: '/my-progress', title: 'My Progress' });
	pathmap.set(`/my-progress`, {
		topic: {},
		view: () => {
			publish(`site/progress`);
		}
	});

	keymap.set('final-test', { path: '/final-test', title: 'Final Test' });
	pathmap.set(`/final-test`, {
		topic: {},
		view: () => {
			publish(`site/final-test`);
		}
	});

	keymap.set('glossary', { path: '/glossary', title: 'Glossary' });
	pathmap.set(`/glossary`, {
		topic: {},
		view: () => {
			publish(`site/glossary`);
		}
	});

	// defaults are ['assessment', 'explore', 'explore-assess', 'explore-practice', 'posttest', 'practice']
	['explore', 'practice', 'posttest'].forEach((loc) => {
		const title = loc === 'assessment' ? 'Pre-Test' : capitalize(loc);
		keymap.set(loc, { path: `/${loc}`, title });
		// don't setup the pathmap for test routes, but still need the keymap
		if (loc === 'explore') {
			pathmap.set(`/${loc}`, {
				topic: {},
				view: () => {
					publish(`site/${loc.split('-').join('/')}`);
				}
			});
		}
	});
	keymap.set('explore', { path: '/explore', title: 'Explore The Study Materials' });
}

export function setup_actions(): void {
	subscribe('site/homepage', () => {
		publish('close-all/panes');
		clearView();
		publish('active-view');
		log('explore');
	});
	subscribe('site/quiz', (topic) => {
		const [, , quizid] = topic.split('/');
		const title = quizid
			.split('-')
			.map((word) => capitalize(word))
			.join(' ');
		viewChange({ view: viewFromLpl(quiz(quizid, title)) });
		publish('close-all/panes');
		locationChange({ location: `/quiz/${quizid}` });
	});
	subscribe('site/assessment', (topic, quiz) => {
		if (quiz) {
			const { title } = keymap.get(quiz)!;
			viewChange({ view: viewFromLpl(assessment(quiz, title)) });
			publish('close-all/panes');
			log(quiz);
		}
	});
	subscribe('site/practice', () => {
		const { quiz } = quizmap.get('practice') || {};
		if (quiz) {
			const { title } = keymap.get('practice')!;
			viewChange({ view: viewFromLpl(practice(quiz, title)) });
			publish('close-all/panes');
			log('practice');
		}
	});
	subscribe('site/posttest', () => {
		const { quiz } = quizmap.get('posttest') || {};
		if (quiz) {
			const { title } = keymap.get('posttest')!;
			viewChange({ view: viewFromLpl(posttest(quiz, title)) });
			publish('close-all/panes');
			log('posttest');
		}
	});
	subscribe('site/bonusquiz', (topic, quizid) => {
		const { path, title } = bonusquizzes.get(quizid) || { title: '' };
		if (path) {
			viewChange({ view: viewFromLpl(bonus(quizid, title)) });
			publish('close-all/panes');
			log(quizid);
		}
	});

	subscribe('site/explore', (topic) => {
		const [, , rest] = topic.split('/');
		const location = rest ? `explore-${rest}` : 'explore';
		publish('close-all/panes');
		clearView();
		if (rest && (rest === 'assess' || rest === 'practice')) {
			whichActiveView({ whichActive: rest });
		}
		log(location);
	});

	subscribe('site/glossary/pane', () => {
		publish('close-all/panes');
		log('glossary');
		publish('glossary/open');
	});
	subscribe('site/video', (topic) => {
		const [, , videoid] = topic.split('/');
		publish('close-all/panes');
		// log(`video/${videoid}`);
		publish('video/open', videoid);
	});
	subscribe('site/rcs', (topic) => {
		const [, , ...rest] = topic.split('/');
		const rcspath = `/${rest.join('/')}`;
		publish('close-all/panes');
		// log(`${rcspath}`);
		publish('rcs/open', rcspath);
	});
	subscribe('site/certificate', () => {
		publish('close-all/panes');
		// log('certificate');
		publish('cert/open');
	});

	subscribe('rcs/view', (topic) => {
		const [, , ...rest] = topic.split('/');
		const rcspath = `/${rest.join('/')}`;
		locationChange({ location: rcspath });
		publish('close-all/panes');
		viewChange({
			view: {
				widget: 'ResourceCenter',
				params: { baseurl: rcspath, url: rcspath }
			}
		});
	});

	subscribe('site/glossary', () => {
		locationChange({ location: '/glossary' });
		publish('close-all/panes');
		viewChange({
			view: {
				widget: 'GlossaryView',
				params: {}
			}
		});
	});

	subscribe('explore/active', () => {
		publish('close-all/panes');
		clearView();
		viewChange({
			view: {
				widget: 'ActiveView',
				params: {}
			}
		});
	});

	subscribe('site/progress', () => {
		publish('close-all/panes');
		clearView();
		locationChange({ location: '/my-progress' });
		viewChange({
			view: {
				widget: 'ProgressView',
				params: {}
			}
		});
	});

	subscribe('site/final-test', () => {
		publish('close-all/panes');
		clearView();
		locationChange({ location: '/final-test' });
		viewChange({
			view: {
				widget: 'FinalTestView',
				params: {}
			}
		});
	});

	setup_locations();
}
